import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import SmartImage from "@/components/common/SmartImage";

function formatDate(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

export default function BlogCard({ post, featured = false }) {
    return (
        <article
            className={`cs-card cs-card-hover group flex flex-col overflow-hidden ${featured ? "md:col-span-2 md:flex-row" : ""}`}
            data-testid={`blog-card-${post.slug}`}
        >
            <Link
                to={`/blogs/${post.slug}`}
                className={`relative block overflow-hidden bg-cs-charcoal ${featured ? "md:w-1/2" : ""}`}
                aria-label={post.title}
            >
                <SmartImage
                    src={post.featuredImage}
                    alt={post.featuredImageAlt || post.title}
                    width={1000}
                    className={`w-full ${featured ? "aspect-[4/3] md:aspect-auto md:h-full" : "aspect-[16/10]"}`}
                    imgClassName="transition-transform duration-[900ms] group-hover:scale-[1.04]"
                />
                <div className="absolute top-3 left-3 cs-chip !bg-white/95 !border-cs-navy !text-cs-navy">
                    {post.category}
                </div>
                {featured && (
                    <div className="absolute top-3 right-3 cs-badge-featured">Featured Article</div>
                )}
            </Link>
            <div className={`p-5 md:p-6 flex flex-col flex-1 ${featured ? "md:w-1/2 justify-center" : ""}`}>
                <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-widest text-cs-steel">
                    <span className="inline-flex items-center gap-1.5">
                        <Calendar size={12} strokeWidth={2} />
                        {formatDate(post.publishedAt)}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                        <Clock size={12} strokeWidth={2} />
                        {post.readingTime} min read
                    </span>
                </div>
                <h3 className={`mt-2 font-heading uppercase text-cs-navy ${featured ? "text-3xl md:text-4xl" : "text-xl md:text-[22px]"}`}>
                    <Link to={`/blogs/${post.slug}`} className="hover:text-cs-orange transition-colors">
                        {post.title}
                    </Link>
                </h3>
                <p className="mt-3 text-sm text-cs-steel leading-relaxed line-clamp-3">
                    {post.excerpt}
                </p>
                <div className="mt-5 flex items-center justify-between">
                    <div className="flex flex-wrap gap-1.5">
                        {post.tags?.slice(0, 3).map((t) => (
                            <span key={t} className="cs-chip !text-[10px] !py-0.5">
                                {t}
                            </span>
                        ))}
                    </div>
                    <Link
                        to={`/blogs/${post.slug}`}
                        className="cs-link-arrow"
                        data-testid={`blog-card-read-${post.slug}`}
                    >
                        Read
                        <ArrowRight size={12} strokeWidth={2} />
                    </Link>
                </div>
            </div>
        </article>
    );
}
